import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b555e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modal",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, " Edit User "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_7 = { class: "form-floating mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Identifier", -1))
const _hoisted_9 = { class: "form-floating mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_11 = { class: "form-floating mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Provider", -1))
const _hoisted_13 = { class: "form-floating mb-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tag Name", -1))
const _hoisted_16 = { class: "form-floating mb-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Role", -1))
const _hoisted_20 = { class: "form-floating mb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Created", -1))
const _hoisted_22 = { class: "form-floating mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Modified", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-secondary border-1" }, null, -1))
const _hoisted_25 = { class: "reset-section" }
const _hoisted_26 = { class: "list" }
const _hoisted_27 = { class: "form-floating mb-3" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Case", -1))
const _hoisted_31 = { class: "reset" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1))
const _hoisted_37 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
                _createElementVNode("button", {
                  class: "btn-close",
                  type: "button",
                  "data-bs-dismiss": "alert",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.error = undefined))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Identifier",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.id) = $event)),
                disabled: true
              }, null, 512), [
                [_vModelText, _ctx.user.id]
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.user.email)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    class: "form-control",
                    placeholder: "Email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event)),
                    disabled: true
                  }, null, 512)), [
                    [_vModelText, _ctx.user.email]
                  ])
                : _createCommentVNode("", true),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Provider",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.provider) = $event)),
                disabled: true
              }, null, 512), [
                [_vModelText, _ctx.user.provider]
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Tag Name",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.tag.name) = $event)),
                disabled: false || _ctx.disabled
              }, null, 8, _hoisted_14), [
                [_vModelText, _ctx.user.tag.name]
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                placeholder: "Role",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.role) = $event)),
                disabled: false || _ctx.disabled
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: role
                  }, _toDisplayString(role), 9, _hoisted_18))
                }), 128))
              ], 8, _hoisted_17), [
                [_vModelSelect, _ctx.user.role]
              ]),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Created",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.created) = $event)),
                disabled: true
              }, null, 512), [
                [_vModelText, _ctx.user.created]
              ]),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Modified",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.modified) = $event)),
                disabled: true
              }, null, 512), [
                [_vModelText, _ctx.user.modified]
              ]),
              _hoisted_23
            ])
          ]),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  placeholder: "Case",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.game) = $event)),
                  disabled: false || _ctx.disabled
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: game
                    }, _toDisplayString(game), 9, _hoisted_29))
                  }), 128))
                ], 8, _hoisted_28), [
                  [_vModelSelect, _ctx.game]
                ]),
                _hoisted_30
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetGame())),
                class: "btn btn-danger",
                type: "button",
                disabled: false || _ctx.disabled,
                title: "Reset user's case progress"
              }, _hoisted_34, 8, _hoisted_32)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateUser())),
            disabled: _ctx.disabled
          }, " Update User ", 8, _hoisted_37)
        ])
      ])
    ])
  ], 512))
}